export default {
      id: "shield-wait-usage",
      viewBox: "0 0 12 13",
      url: __webpack_public_path__ + "img/icons.svg#shield-wait",
      toString: function () {
        return this.url;
      }
    }